import axios from "axios";
import { cleanCookies } from "../utils/Utils";
import { getUSER } from "./auth";
import { getNodeToken } from "./auth_node";

const local = axios.create({
  baseURL: "http://localhost:3333/v2/",
  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

local.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && window.location.href.indexOf("login") < 0) {
      if (401 === error.response.status) {
        localStorage.setItem("redirect", window.location.pathname);
        localStorage.removeItem("Token");
        localStorage.removeItem("oauth_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("USER");
        localStorage.removeItem("USER_NODE");

        cleanCookies().then(() => {
          window.location.href = "/login";
        });
      }
    }
    return Promise.reject(error);
  }
);

const local_noauth = axios.create({
  baseURL: "http://localhost:3333/v2/",
  headers: {
    id_php: getUSER().id,
  },
});

const heroku = axios.create({
  baseURL: "https://voittoapi.herokuapp.com/v2/",
  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

const heroku_noauth = axios.create({
  baseURL: "https://voittoapi.herokuapp.com/v2/",
  headers: {
    id_php: getUSER().id,
  },
});

const producaov2 = axios.create({
  baseURL: "https://api.voitto.com.br/v2/",
  // baseURL: "http://localhost:3333/v2/",

  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

const apiRelatorios = axios.create({
  baseURL: "https://apirelatorios.voitto.com.br/",
  // baseURL: "http://localhost:4444/",

  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

const node_api = axios.create({
  baseURL:
    window.location.href.indexOf("localhost") > -1
      ? "http://localhost:3333/v2/"
      : "https://apiv2.voitto.com.br/v2/",
  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

const voittoapi = axios.create({
  baseURL: "http://192.168.1.104:3333/v2/",
  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

producaov2.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(error.response);
    } else if (error.request) {
      console.error(error.request);
    } else {
      console.error("Error", error.message);
    }
    if (error.response && window.location.href.indexOf("login") < 0) {
      if (401 === error.response.status) {
      }
    }
    return Promise.reject(error);
  }
);

const producaov2_noauth = axios.create({
  baseURL: "https://apiv2.voitto.com.br/v2/",
  // baseURL: "http://localhost:3333/v2/",
  headers: {
    id_php: getUSER().id,
  },
});

const phpLocal = axios.create({
  baseURL: "http://localhost/voitto_2.0/api/",
});

const apiPhpLocal = axios.create({
  baseURL: "http://api.voitto.local/",
});

const pb4y = axios.create({
  baseURL: "https://apiv2.pocketbook4you.com/",
});
const pb4yLocal = axios.create({
  baseURL: "http://localhost:3333/",
});

// const producaoLegacy = axios.create({
//   baseURL: "https://api.voitto.com.br/",
// });

// const producao = axios.create({
//   baseURL: "https://apiv1.voitto.com.br/",
// });

const certificado_api = axios.create({
  baseURL: "https://apicertificado.voitto.com.br/",
  headers: {
    access_token: `voitto-token ${getNodeToken()}`,
  },
});

const relatorio_api = axios.create({
  baseUrl: "https://apirelatorios.voitto.com.br/",
});

export {
  local,
  local_noauth,
  heroku,
  heroku_noauth,
  voittoapi,
  producaov2,
  producaov2_noauth,
  apiRelatorios,
  phpLocal,
  apiPhpLocal,
  // producaoLegacy,
  // producao,
  node_api,
  certificado_api,
  pb4y,
  pb4yLocal,
  relatorio_api,
};
